import React from 'react';
import { _T } from '../../../include/appI18n';
const baggageKeys = [
    'багаж',
    'bagazh',
    'baggage',
    'luggage',
    'checked baggage',
    'checked luggage',
    'checked bag',
    'check-in baggage',
    'check in baggage',
].map(x => x.toLowerCase());
const handBaggageKeys = [
    'ручная кладь',
    'ручн. кладь',
    'ручная',
    'ручн багаж',
    'ручной багаж',
    'hand luggage',
    'hand baggage',
    'cabin baggage',
    'cabin luggage',
    'cabin bag',
    'carry-on',
    'carry on',
    'carry-on baggage',
    'carry-on luggage',
].map(x => x.toLowerCase());
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const containsAny = (text, keys) => keys.some(key => text.includes(key));
const cleanLabel = (text, keys) => {
    let result = text;
    keys.forEach((key) => {
        const pattern = new RegExp(`^\\s*${escapeRegExp(key)}\\s*[:\\-–]*\\s*`, 'i');
        result = result.replace(pattern, '');
    });
    return result.trim().replace(/^[\s;,.\-–]+|[\s;,.\-–]+$/g, '');
};
const unique = (values) => Array.from(new Set(values.filter(Boolean)));
export const parseFlightBaggage = (raw) => {
    if (!raw)
        return [];
    const normalized = raw.replace(/<br\s*\/?>/gi, '\n');
    const chunks = normalized
        .split(/[\n;]+/)
        .map(x => x.trim())
        .filter(x => x.length > 0);
    const result = [];
    chunks.forEach((chunk) => {
        const text = chunk.trim();
        const lower = text.toLowerCase();
        if (containsAny(lower, baggageKeys) && containsAny(lower, handBaggageKeys) && text.includes('+')) {
            text.split('+').forEach((part) => {
                const p = part.trim();
                const pl = p.toLowerCase();
                if (containsAny(pl, baggageKeys))
                    result.push({ type: 'baggage', description: cleanLabel(p, baggageKeys) });
                else if (containsAny(pl, handBaggageKeys))
                    result.push({ type: 'hand', description: cleanLabel(p, handBaggageKeys) });
            });
            return;
        }
        if (containsAny(lower, baggageKeys))
            result.push({ type: 'baggage', description: cleanLabel(text, baggageKeys) });
        else if (containsAny(lower, handBaggageKeys))
            result.push({ type: 'hand', description: cleanLabel(text, handBaggageKeys) });
    });
    return result;
};
export const getFlightBaggageSummary = (raw) => {
    const items = parseFlightBaggage(raw);
    return {
        baggage: unique(items.filter(x => x.type == 'baggage').map(x => x.description)),
        hand: unique(items.filter(x => x.type == 'hand').map(x => x.description)),
    };
};
export function InternalFlightBaggageCompact({ luggageDescription }) {
    if (luggageDescription == null)
        return React.createElement("span", { className: "text-grey" }, _T.FLIGHT_SEARCH_WITHOUT_BAGGAGE);
    const { baggage, hand } = getFlightBaggageSummary(luggageDescription);
    return (React.createElement(React.Fragment, null,
        baggage.length
            ? React.createElement("span", { className: "text-grey" },
                _T.FLIGHT_SEARCH_BAGGAGE,
                ": ",
                baggage.join(', '))
            : React.createElement("span", { className: "text-grey" }, _T.FLIGHT_SEARCH_WITHOUT_BAGGAGE),
        hand.length
            ? React.createElement("span", { className: "text-grey" },
                _T.FLIGHT_SEARCH_HAND_BAGGAGE,
                ": ",
                hand.join(', '))
            : React.createElement("span", { className: "text-grey" }, _T.FLIGHT_SEARCH_WITHOUT_HAND_BAGGAGE)));
}
export function InternalFlightBaggageRows({ luggageDescription }) {
    if (luggageDescription == null) {
        return (React.createElement("div", { className: "info-list-prop" },
            React.createElement("span", { className: "info-list-prop-name" }, _T.FLIGHT_SEARCH_WITHOUT_BAGGAGE)));
    }
    const { baggage, hand } = getFlightBaggageSummary(luggageDescription);
    return (React.createElement(React.Fragment, null,
        baggage.length
            ? React.createElement("div", { className: "info-list-prop" },
                React.createElement("span", { className: "info-list-prop-name" },
                    _T.FLIGHT_SEARCH_BAGGAGE,
                    ": "),
                React.createElement("span", { className: "info-list-prop-val" }, baggage.join(', ')))
            : React.createElement("div", { className: "info-list-prop" },
                React.createElement("span", { className: "info-list-prop-name" }, _T.FLIGHT_SEARCH_WITHOUT_BAGGAGE)),
        hand.length
            ? React.createElement("div", { className: "info-list-prop" },
                React.createElement("span", { className: "info-list-prop-name" },
                    _T.FLIGHT_SEARCH_HAND_BAGGAGE,
                    ": "),
                React.createElement("span", { className: "info-list-prop-val" }, hand.join(', ')))
            : React.createElement("div", { className: "info-list-prop" },
                React.createElement("span", { className: "info-list-prop-name" }, _T.FLIGHT_SEARCH_WITHOUT_HAND_BAGGAGE))));
}
